if (!customElements.get('scrollable-swatches')) {
  class ScrollableSwatches extends HTMLElement {
    constructor() {
      super();
      this.isDown = false;
      this.startX = 0;
      this.initScrollLeft = 0;
      this.bindOnMouseDown = this.onMouseDown.bind(this);
      this.bindOnMouseUp = this.onMouseUp.bind(this);
      this.bindOnMouseMove = this.onMouseMove.bind(this);
    }

    connectedCallback() {
      this.scrollContainer = this.querySelector('.related-products__fieldset--scroll');
      if (!this.scrollContainer) return;
      this.scrollElement = this.scrollContainer.querySelector('.related-products__swatch-items') || this.scrollContainer;
      this.scrollContainer.addEventListener('mousedown', this.bindOnMouseDown, { passive: false });
    }

    disconnectedCallback() {
      this.scrollContainer?.removeEventListener('mousedown', this.bindOnMouseDown);
    }

    onMouseDown(event) {
      event.preventDefault();
      this.isDown = true;
      this.scrollContainer.classList.add('grabbing');
      this.startX = event.pageX - this.scrollElement.offsetLeft;
      this.initScrollLeft = this.scrollElement.scrollLeft;
      this.scrollContainer.addEventListener('mouseleave', this.bindOnMouseUp, { passive: false });
      this.scrollContainer.addEventListener('mouseup', this.bindOnMouseUp, { passive: false });
      this.scrollContainer.addEventListener('mousemove', this.bindOnMouseMove, { passive: false });
    }

    onMouseMove(event) {
      event.preventDefault();
      if (!this.isDown) return;
      this.scrollContainer.classList.add('moving');
      const x = event.pageX - this.scrollElement.offsetLeft;
      const walk = x - this.startX;
      this.scrollElement.scrollLeft = this.initScrollLeft - walk;
    }

    onMouseUp() {
      this.isDown = false;
      this.scrollContainer.classList.remove('grabbing', 'moving');
      this.scrollContainer.removeEventListener('mouseleave', this.bindOnMouseUp);
      this.scrollContainer.removeEventListener('mouseup', this.bindOnMouseUp);
      this.scrollContainer.removeEventListener('mousemove', this.bindOnMouseMove);
    }
  }

  customElements.define('scrollable-swatches', ScrollableSwatches);
}
